import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from '../menu'
import errores from '../../middleware/errordb'
import back from '../../back.svg';
import config from '../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';

class Formularioformapago extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Impuestos",
            msg: 0,
            comp: "",
            id_impuestos: "",
            empresa: currentCompany,
            descripcion: "",
            tasa: "",
            tipo_impuesto: "",
            erp_code:"",
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: ""
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_impuestos = "";
        const categoriaEdicion = search.replace('?', '');
        if (categoriaEdicion) {
            titulo = "Modificar Impuestos";
            id_impuestos = categoriaEdicion;
            const datasend = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/taxes/' + categoriaEdicion, datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        this.setState({
                            //descripcion: datos[0]["CODIGO_EMPRESA"],
                            descripcion: datos[0]["DESCRIPCION_IMPUESTO"],
                            tasa: datos[0]["TASA_PORCENTAJE"],
                            tipo_impuesto: datos[0]["TIPO_LIQUIDACION_IMPUESTO"],
                            erp_code: datos[0]["ERP_CODE_IMP"]
                        });
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: data.message })
                    }
                });
        } else {
            titulo = "Crear Impuestos";
            id_impuestos = "";
        }
        this.setState({ id_impuestos, titulo });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        const { empresa } = this.state
        const { descripcion } = this.state
        const { tasa } = this.state
        const { tipo_impuesto } = this.state 
        const { erp_code } = this.state 

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa: empresa,
                descripcion: descripcion,
                tasa: tasa,
                tipo_impuesto: tipo_impuesto,
                erp_code
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_impuestos === "") {
            ruta = config.servBackEnd + '/taxes/create';
        } else {
            ruta = config.servBackEnd + '/taxes/modify/' + this.state.id_impuestos;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevoImpuesto = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_impuestos;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_impuestos: nuevoImpuesto })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Impuestos con errores:" + errores[data.code] +" " + data.message })
                }
            });
        event.preventDefault();
    }

    handleClose = () => {
        this.setState({show: false});
    };

    render() {
        const mensajeBoton = (this.state.id_impuestos === "") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_impuestos === "") ? '¿Esta seguro que desea crear el impuesto?' : '¿Esta seguro que desea modificar el impuesto?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        return (
            <div className="Formularioformapago">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Impuestos!</Tooltip>}>
                            <div className="div-back">
                                <a href="/impuestos/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Descripcion</Form.Label>
                                            <Form.Control type="text" placeholder="Descripcion" onChange={e => this.setState({ descripcion: e.target.value.toUpperCase() })} value={this.state.descripcion} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Tipo</Form.Label>
                                            <Form.Control as="select" maxLength="2" placeholder="codigo" onChange={e => this.setState({ tipo_impuesto: e.target.value })} value={this.state.tipo_impuesto} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">Porcentaje</option>
                                                {/* <option value="2">Valor</option> */}
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Valor</Form.Label>
                                            <Form.Control type="number" min="0" step=".01" max={(this.state.tipo_impuesto === "1") ? 100 : 999999999} placeholder="valor" onChange={e => this.setState({ tasa: e.target.value })} value={this.state.tasa} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Codigo ERP</Form.Label>
                                            <Form.Control type="text"  placeholder="valor" onChange={e => this.setState({ erp_code: e.target.value })} value={this.state.erp_code} />
                                        </Form.Group>

                                    </Form.Row>

                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (Formularioformapago);